import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'fl-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss'],
})
export class MessageBoxComponent implements OnInit {
  @Input()
  public level: 'error' | 'info' | 'success' = 'info';
  @Input()
  public messages: string[] = [];

  constructor() {}

  public ngOnInit() {}

  get anyMessages(): boolean {
    return this.messages != null && this.messages.length > 0;
  }

  get levelClass(): string {
    return `message_box-${this.level}`;
  }
}
